module.exports = __webpack_public_path__ + "media/images/flags/64/Liechtenstein-1f8b815d88c8f5b5a0d0c6a250e9dbec.png";